// A labour card shows only its expiry, so the issue date is derived from it. The
// first card from HHC is issued for 2 months; every card after it runs 2 years.
// A term ends the day before its anniversary, so issue = (expiry + 1 day) minus
// the term: expiry 2026-12-25 on a first card → issue 2026-10-26; expiry
// 2027-07-23 on a 2-year card → issue 2025-07-24.
const FIRST_CARD_MONTHS = 2;
const FULL_CARD_MONTHS = 24;

export const deriveWorkPermitIssueDate = (expiryStr, isFirstCard) => {
    if (!expiryStr) return '';
    const [y, m, d] = String(expiryStr).split('-').map(Number);
    if (!y || !m || !d) return '';
    const dayAfter = new Date(y, m - 1, d + 1);
    const months = isFirstCard ? FIRST_CARD_MONTHS : FULL_CARD_MONTHS;
    const dt = new Date(dayAfter.getFullYear(), dayAfter.getMonth() - months, dayAfter.getDate());
    const p = (n) => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${p(dt.getMonth() + 1)}-${p(dt.getDate())}`;
};

// The switch's starting position when an expiry is typed: a first card is someone
// with no first-card date on record, on a card ending within about 3 months of
// today. Anything further out can only be a 2-year card.
export const looksLikeFirstCard = (expiryStr, hasFirstCardDate) => {
    if (!expiryStr || hasFirstCardDate) return false;
    const limit = new Date();
    limit.setMonth(limit.getMonth() + 3);
    return new Date(`${expiryStr}T00:00:00`) <= limit;
};

// A saved record: is its issue date the 2-month reading of its expiry?
export const isStoredFirstCard = (issueStr, expiryStr) =>
    !!issueStr && !!expiryStr && deriveWorkPermitIssueDate(expiryStr, true) === issueStr;

export const issueDateHelper = (isFirstCard) =>
    `Auto-calculated from the expiry date (${isFirstCard ? '−2 months' : '−2 years'} + 1 day)`;
